import React from "react";
import Button from "./Button";
import Configuration from "./shared/configuration";
import Spinner from "./Spinner";
import DownloadButton from "./DownloadButton";
import ImageLoader from "react-imageloader";
import "./ImageEditor.css";

export default function ImageEditor({ configuration, strings }) {
  return (
    <div className="ImageEditor">
      <div>
        <ImageLoader
          src={Configuration.configurationToRenderUrl(
            configuration,
            true,
            "left"
          )}
          wrapper={React.DOM.div}
          preloader={Spinner}
        >
          Image load failed!
        </ImageLoader>
        <div className="buttons">
          <div className="angleButtons">
            <Button
              path={Configuration.configurationToUrl(
                Configuration.configurationWithChange(configuration, {
                  angle: "left"
                })
              )}
              title={strings.angleLeft}
              active={configuration.angle === "left"}
            />
            <Button
              path={Configuration.configurationToUrl(
                Configuration.configurationWithChange(configuration, {
                  angle: "front"
                })
              )}
              title={strings.angleFront}
              active={configuration.angle === "front"}
            />
            <Button
              path={Configuration.configurationToUrl(
                Configuration.configurationWithChange(configuration, {
                  angle: "right"
                })
              )}
              title={strings.angleRight}
              active={configuration.angle === "right"}
            />
          </div>
          <div className="disclaimer">
            <span>{strings.disclaimer}</span>
          </div>
          <div>
            <DownloadButton
              url={Configuration.configurationToRenderUrl(configuration, true)}
              title={strings.exportImage}
              exportingString={strings.exporting}
              suffix=".png"
            />
            <DownloadButton
              url={Configuration.configurationToPdfUrl(configuration)}
              title={strings.exportPdf}
              exportingString={strings.exporting}
              suffix=".pdf"
            />
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/ImageEditor.js